import React, { useCallback, useState } from 'react'
import ProgKeyCtrl from './progKey/ProgKeyCtrl'
import KeyTitleCtrl from './keyTitle/KeyTitleCtrl'
import ValCell from './val/ValCell'
import MetaCell from './meta/MetaCell'
import Boswana from './boswana/Boswana'
import ConfigNote from './note/ConfigNote'
import DeleteRow from './controls/DeleteRow'
import { camelCase } from '../../../hooks/useMyStrings'
import { K_INFO, K_VALUE } from '../../../providers/ConfigsDataContextProvider'
import './ConfigItem.css'

export const processedTitle = (title, keyName) => {
  return title ? title : camelCase(keyName);
}

export default function ConfigItem({folderPath, folder, keyName, boswana}) {  // progKey, value, title, note, kInfo,
  const [ctrlButtons, setCtrlButtons] = useState('off');// off, faded, on
  const [showConfirm, setShowConfirm] = useState(false);

  const showCtrls = useCallback(() => {
    setCtrlButtons('on');
  }, []);

  const hideCtrls = useCallback(() => {
    setCtrlButtons('off');
  }, []);

  const fadeCtrls = useCallback(() => {
    setCtrlButtons('faded');
  }, []);

  // --- Render ---
  const kInfo = folder[keyName][K_INFO];  
  const value = folder[keyName][K_VALUE];
  const note  = kInfo.note;

  return (
    <div className='configItem'>
      <div className='ctrlButtons' onMouseEnter={showCtrls} onMouseLeave={hideCtrls}>
        {!showConfirm &&  <DeleteRow showLevel={ctrlButtons} confirmer={()=>setShowConfirm(true)} />}
      </div>
      
      {boswana && <Boswana        keyName={keyName} kInfo={kInfo} tabIx={4} />}

      {!boswana && <KeyTitleCtrl  folderPath={folderPath} keyName={keyName} kInfo={kInfo} setShowConfirm={setShowConfirm} 
                                  deleteMode={showConfirm} tabIx={3} onMouseEnter={fadeCtrls} onMouseLeave={hideCtrls}/>}

      {!boswana && <ProgKeyCtrl   folderPath={folderPath} keyName={keyName} kInfo={kInfo} tabIx={2} 
                                  onMouseEnter={fadeCtrls} onMouseLeave={hideCtrls}/>}

      <ValCell                    folderPath={folderPath} keyName={keyName} kInfo={kInfo} value={value} tabIx={1} />
      <ConfigNote                 text={note} />      
      <MetaCell                   kInfo={kInfo}/>
      <div className='ctrlRight'></div>
    </div>
  )
}
